
document.addEventListener('DOMContentLoaded', function () {
const colorItems = document.querySelectorAll('.product__custom-colors-item');
const activeName = document.querySelector('.product__custom-color-active');

if (colorItems.length && activeName) {
colorItems.forEach(item => {
item.addEventListener('mouseenter', () => {
activeName.textContent = item.getAttribute('data-color-name');
});
item.addEventListener('mouseleave', () => {
activeName.textContent = colorItems[0].getAttribute('data-color-name');
});
});
}
});
